import { isFeaturedWorkout, isFeaturedAthlete, isFeaturedPlan, } from "../api";
import { getInfoImageFromWorkout, getGridImageFromWorkout } from "./getVideo";
export const getEntryFromFeatured = (feat) => {
    if (isFeaturedAthlete(feat)) {
        const athlete = feat.content;
        return getEntryFromAthlete(athlete);
    }
    if (isFeaturedPlan(feat)) {
        const plan = feat.content;
        return getEntryFromPlan(plan);
    }
    if (isFeaturedWorkout(feat)) {
        const workout = feat.content;
        return getEntryFromWorkout(workout);
    }
    throw new Error("Unknown Featured type");
};
export const getEntryFromAthlete = (athlete) => {
    const mobileOnly = false; //athlete.mobileOnly ?? !athlete.available;
    return {
        type: "athlete",
        url: `/athlete/${athlete.id}`,
        mobileOnly,
        title: `${athlete.firstName} ${athlete.lastName}`,
        subtitle: athlete.shortDescription,
        imageUrl: `${athlete.imageWideUrl}?tr=w-500`,
    };
};
export const getEntryFromPlan = (plan) => {
    const mobileOnly = false; //plan.mobileOnly ?? !plan.available;
    return {
        type: "plan",
        url: `/plan/${plan.id}`,
        mobileOnly,
        title: plan.name,
        subtitle: `By ${plan.athleteFirstName} ${plan.athleteLastName}`,
        imageUrl: `${plan.imageSmallUrl}?tr=w-500`,
    };
};
export const getEntryFromWorkout = (workout) => {
    const mobileOnly = false; // workout.mobileOnly ?? !workout.available;
    return {
        type: "workout",
        url: `/workout/${workout.id}`,
        mobileOnly,
        title: workout.name,
        imageUrl: `${getInfoImageFromWorkout(workout)}?tr=w-500`,
    };
};
export const getHistoryFromWorkout = (workout) => ({
    type: "workout",
    url: `/workout/${workout.workoutId}`,
    title: workout.name,
    mobileOnly: false,
    imageUrl: `${getInfoImageFromWorkout(workout)}?tr=w-500`,
});
export const getHistoryFromPlan = (plan) => {
    var _a;
    return ({
        type: "plan",
        url: `/plan/${plan.planId}`,
        title: plan.planName,
        subtitle: `By ${plan.athleteFirstName} ${plan.athleteLastName}`,
        mobileOnly: (_a = plan.mobileOnly, (_a !== null && _a !== void 0 ? _a : !plan.available)),
        imageUrl: `${plan.imageSmall || plan.imageTv || plan.image}?tr=w-500`,
    });
};
export const getCarouselEntryFromWorkout = (workout, index) => {
    return {
        id: workout.id,
        url: `/workout/${workout.id}`,
        title: workout.name,
        subtitle: `Day ${index + 1}`,
        first: `${workout.expectedDuration} mins  ·  home`,
        second: workout.equipment,
        imageUrl: `${getGridImageFromWorkout(workout)}?tr=w-500`,
        completed: workout.completed,
        mobileOnly: false,
    };
};
//# sourceMappingURL=data:application/json;base64,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